import {
  IForgotPasswordUser,
  ILoginUser,
  IVerifyUser,
} from '../../shared/interfaces/user/IUser';
import { requests } from '../../utils/api/api.service';
import { BASE_URL, LOGIN_URL, USER_URL } from '../../utils/api/endpoints';

export const AuthService = {
  login: (payload: ILoginUser) => requests.post(LOGIN_URL, payload),
  enums: () => requests.get(BASE_URL + '/enums'),
  me: (token: string) => requests.get(`${USER_URL}/me?token=${token}`),
  resendOtp: (email: string) =>
    requests.put(`${USER_URL}/resend-otp`, { email }),
  verifyUser: (payload: IVerifyUser) =>
    requests.put(`${USER_URL}/verify-user`, payload),
  sendPasswordOtp: (email: string) =>
    requests.put(`${USER_URL}/password-otp`, { email }),
  resetPassword: (payload: IForgotPasswordUser) =>
    requests.put(`${USER_URL}/reset-password`, payload),
};
